import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import CompanyContactsTable from "../../companies/contacts/table";
import MdArrowDropdown from "react-icons/lib/md/arrow-drop-down";
import MdArrowUp from "react-icons/lib/md/arrow-drop-up";

const ComplianceTeamCompanyContacts = ({
  minimizeAll,
  requestedDates,
  data
}) => {
  const [isMinimized, setMinimized] = useState(false);

  useEffect(() => {
    setMinimized(minimizeAll);
  }, [minimizeAll, setMinimized]);

  return (
    <div className="compliance-block compliance-company-contacts">
      <div className="compliance-block-header">
        <span
          style={{ cursor: "pointer" }}
          onClick={() => setMinimized(!isMinimized)}
        >
          Contacts
          <i className="flat-icon-button">
            {isMinimized ? <MdArrowDropdown /> : <MdArrowUp />}
          </i>
        </span>
      </div>
      {!isMinimized && (
        <div className="block-content">
          <CompanyContactsTable data={data} dates={requestedDates} />
        </div>
      )}
    </div>
  );
};

ComplianceTeamCompanyContacts.propTypes = {
  requestedDates: PropTypes.object.isRequired,
  minimizeAll: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default ComplianceTeamCompanyContacts;
